import React, { useMemo, useEffect, useState, useContext } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { useTranslation } from "react-i18next";
import { GatsbyImage } from "gatsby-plugin-image";

import { ProductBadge } from "./ProductBadge";
import { ProductTitle } from "./ProductTitle";
import { ServicesContext } from "@sbi-international/boutik.gatsby.plugin.services/dist/src/contexts/servicesContext";
import { IProduct } from "@sbi-international/boutik.gatsby.plugin.services";
import { LocalizedLink } from "../primitives";
import { AddItemButton } from "@sbi-international/boutik.gatsby.plugin.checkout";
import { getAvailability } from "../../utils/productAvailabilityInfo";
import { ProductPrice } from "../price/ProductPrice";
import { ProductStock } from "@sbi-international/boutik.gatsby.plugin.components";

type ProductListingSingleProps = {
    product: any;
};

export default function ProductListingSingle(props: ProductListingSingleProps) {
    const [productData, setProductData] = useState<IProduct>();
    const [buttonLabel, setButtonLabel] = useState<string>();
    const servicesContext = useContext(ServicesContext);
    const productService = servicesContext?.magento.productService;

    useEffect(() => {
        productService.operations.getProduct(product?.code).then((product) => {
            if (product) {
                let buttonLabel =
                    productData?.currentStock?.status == "in-stock" ? " " : t("pre-order");

                if (productData?.currentStock?.status !== "out-of-stock") {
                    buttonLabel = " ";
                }
                setButtonLabel(buttonLabel);
                setProductData(product);
            }
        });
    }, [props.product?.code]);

    const { product } = props;
    const allProducts = useStaticQuery(
        graphql`
            query ListingSingleComponent {
                allProductsJson {
                    nodes {
                        slug {
                            en_CA
                            fr_CA
                            en_US
                        }
                        code
                        images
                        fields {
                            ...productsFieldsImagesFragment
                        }
                    }
                }
            }
        `
    );

    const products = allProducts.allProductsJson.nodes;
    const product2 = useMemo(
        () => products.find((product2: any) => product2.code === product.code),
        [products, product]
    );

    const { t } = useTranslation("templatePages");

    const gatsbyImageData =
        product2 && product2.fields?.images?.[0]?.childImageSharp?.gatsbyImageData;

    return (
        <div className="productListingSingle">
            <div className="productListingWrap">
                <div className="product-img-wrap">
                    <ProductBadge product={product} />

                    {gatsbyImageData && <GatsbyImage image={gatsbyImageData} alt="" />}
                </div>

                <div className="product-info">
                    <div className="title-div">
                        <LocalizedLink className="productListingWrap" to={products.slug}>
                            <>
                                {" "}
                                {product.title && (
                                    <ProductTitle product={product} reviews={undefined} />
                                )}
                            </>
                        </LocalizedLink>
                    </div>

                    <div className="sku">{product.code}</div>

                    <ProductPrice
                        currentPrice={productData?.currentPrice}
                        prefixClassName="product-listing-single"
                    />
                    <ProductStock
                        currentStock={productData?.currentStock}
                        type="medium"
                        isCustomMade={false}
                    />
                </div>
                <AddItemButton
                    type={"small"}
                    sku={product.code}
                    availability={getAvailability(productData?.currentStock)}
                />
            </div>
        </div>
    );
}
